module.exports = __webpack_public_path__ + "static/media/01.969e4460.jpg";